import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Router } from '@angular/router';
const screenfull = require('screenfull');
import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { Repository } from '../../services/repository'
import { TranslationService } from '../../services/translation.service'
import {
  KhoaHocs_HocThu, KhoaHocs_TuyenSinh, DaoTaos_GiangVien
  , KhoaHocs_KiemTraDauVao, DaoTaos_HocVien, KhoaHocs_DiemDanh
  , DaoTaos_solienlac, Reports_baocao, KhoaHocs_QuanLyThuChi
  , Lists_QuanLyNhapKho, Lists_QuanLyXuatKho, Lists_nhacungcap, Lists_sanpham
  , Lists_khohang, Lists_baiviet, Lists_mauthongbao, Lists_taikhoanbank,
  Lists_guithongbao, KhoaHocs_ThongTinKhoaHoc, Lists_dmphonghoc, KhoaHocs_KhoaHoc,
  Lists_donvitinh, Lists_lophoc, DaoTaos_HocPhi, Lists_dmkenh, Lists_hedaotao, Lists_trinhdodaotao,
  System_thamso, Ultil_nhatkytruycap
} from 'src/app/routes/menu';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  tendonvi: string = null;
  donviid: string = null;
  ten_don_vi: string = null;
  ngay_het_han: string = null;

  khoitao: boolean = true;
  hocvientiemnang: boolean = true;
  hocthu: boolean = true;
  kiemtradauvao: boolean = true;
  hocvien: boolean = true;
  diemdanh: boolean = true;
  solienlac: boolean = true;
  baocao: boolean = true;
  quanlynhansu: boolean = true;
  quanlyhocphi: boolean = true;
  thuchi: boolean = true;
  nhapkho: boolean = true;
  xuatkho: boolean = true;
  donvitinh: boolean = true;
  nhacungcap: boolean = true;
  sanpham: boolean = true;
  dmtaikhoan: boolean = true;
  dmkhoahoc: boolean = true;
  khohang: boolean = true;
  baiviet: boolean = true;
  nhatkytruycap: boolean = true;
  mauthongbao: boolean = true;
  guithongbao: boolean = true;
  dmlophoc: boolean = true;
  dmphonghoc: boolean = true;
  dmkenh: boolean = true;
  dmhedaotao: boolean = true;
  dmtrinhdo: boolean = true;
  chuongtrinhhoc: boolean = true;
thamsohethong: boolean = true;
  loaivaitro: string = null;



  dschinhanhs: any = [];
  username: string;
    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    router: Router;
  ngon_ngu: any = 1;
    isNavSearchVisible: boolean;
    @ViewChild('fsbutton', { static: true }) fsbutton;  // the fullscreen button
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return  item.Ten.toLowerCase().indexOf(term) > -1;
  }
  public changedv($event: any) {

    if (typeof $event === "undefined") {
      
    }
    else {
      this.donviid = $event.Id;
      this.ten_don_vi = $event.Ten;
     
      // Load ngay_het_han cho đơn vị mới
      this.repo.getRequest('api/hocvien/gethandonvi', { donviid: this.donviid })
        .subscribe(response => {
          if (response && response.Success) {
            this.ngay_het_han = response.NgayHetHan;
            
            // Cập nhật ngay_het_han vào localStorage
            var currentUser1 = localStorage.getItem('currentUser');
            let data = JSON.parse(currentUser1);
            data.ngay_het_han = response.NgayHetHan;
            localStorage.setItem('currentUser', JSON.stringify(data));
          }
        });

      this.repo.getRequest("api/login/getthamsoht/", { donviid: this.donviid })
        .subscribe(response => {
          localStorage.setItem('ThamSos', JSON.stringify(response.dsthamso));         
        });
      
      var currentUser1 = localStorage.getItem('currentUser');
      let data = JSON.parse(currentUser1);
      data.id_don_vi = $event.Id;
      data.ten_don_vi = $event.Ten;
      localStorage.setItem('currentUser', JSON.stringify(data));
      window.location.reload();
    }

  }
  constructor(public menu: MenuService, public userblockService: UserblockService, public settings: SettingsService, public injector: Injector, public repo: Repository, public translateservice: TranslationService) {

        // show only a few items on demo
        //this.menuItems = menu.getMenu().slice(0, 1); // for horizontal layout
    var currentUser1 = localStorage.getItem('currentUser');
    let data = JSON.parse(currentUser1);
    if (data != null) {
      this.username = data.user_name;
      this.donviid = data.id_don_vi;
      this.ten_don_vi = data.ten_don_vi;
      this.loaivaitro = data.loai;
      
      // Fetch expiration date if not in currentUser data
      if (!data.ngay_het_han) {
        this.repo.getRequest('api/hocvien/gethandonvi', { donviid: this.donviid })
          .subscribe(response => {
            if (response && response.Success) {
              this.ngay_het_han = response.NgayHetHan;
            }
          });
      } else {
        this.ngay_het_han = data.ngay_het_han;
      }

      this.repo.postRequest('api/login/gettrungtams', { UserName: this.username })
        .subscribe(response => {
          this.dschinhanhs = response;
          this.donviid = data.id_don_vi;
        });

      var giatri = data.ds_quyen.filter(name => name.Id === DaoTaos_GiangVien.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true) {
          this.khoitao = true;
          this.quanlynhansu = true;
        }
        else {
          this.khoitao = false;
          this.quanlynhansu = false;
        }
      }
      var giatri = data.ds_quyen.filter(name => name.Id === DaoTaos_HocPhi.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true) {
          this.khoitao = true;
          this.quanlyhocphi = true;
        }
        else {
          this.khoitao = false;
          this.quanlyhocphi = false;
        }
      }

      giatri = data.ds_quyen.filter(name => name.Id === KhoaHocs_TuyenSinh.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.hocvientiemnang = true; 
        else
          this.hocvientiemnang = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === KhoaHocs_HocThu.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.hocthu = true;
        else
          this.hocthu = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === KhoaHocs_KiemTraDauVao.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.kiemtradauvao = true;
        else
          this.kiemtradauvao = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === DaoTaos_HocVien.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.hocvien = true;
        else
          this.hocvien = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === KhoaHocs_DiemDanh.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.diemdanh = true;
        else
          this.diemdanh = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === DaoTaos_solienlac.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.solienlac = true;
        else
          this.solienlac = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Reports_baocao.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.baocao = true;
        else
          this.baocao = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === KhoaHocs_QuanLyThuChi.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.thuchi = true;
        else
          this.thuchi = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_QuanLyNhapKho.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.nhapkho = true;
        else
          this.nhapkho = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_QuanLyXuatKho.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.xuatkho = true;
        else
          this.xuatkho = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_donvitinh.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.donvitinh = true;
        else
          this.donvitinh = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_nhacungcap.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.nhacungcap = true;
        else
          this.nhacungcap = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_sanpham.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.sanpham = true;
        else
          this.sanpham = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === KhoaHocs_ThongTinKhoaHoc.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.dmtaikhoan = true;
        else
          this.dmtaikhoan = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_taikhoanbank.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.dmkhoahoc = true;
        else
          this.dmkhoahoc = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_khohang.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.khohang = true;
        else
          this.khohang = false;
      }

      giatri = data.ds_quyen.filter(name => name.Id === Lists_baiviet.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.baiviet = true;
        else
          this.baiviet = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Ultil_nhatkytruycap.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.nhatkytruycap = true;
        else
          this.nhatkytruycap = false;
      }
      

      giatri = data.ds_quyen.filter(name => name.Id === Lists_guithongbao.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.guithongbao = true;
        else
          this.guithongbao = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_mauthongbao.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.mauthongbao = true;
        else
          this.mauthongbao = false;
      }

      giatri = data.ds_quyen.filter(name => name.Id === Lists_lophoc.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.dmlophoc = true;
        else
          this.dmlophoc = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_dmphonghoc.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.dmphonghoc = true;
        else
          this.dmphonghoc = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_dmkenh.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.dmkenh = true;
        else
          this.dmkenh = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_hedaotao.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.dmhedaotao = true;
        else
          this.dmhedaotao = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === Lists_trinhdodaotao.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.dmtrinhdo = true;
        else
          this.dmtrinhdo = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === KhoaHocs_KhoaHoc.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.chuongtrinhhoc = true;
        else
          this.chuongtrinhhoc = false;
      }
      giatri = data.ds_quyen.filter(name => name.Id === System_thamso.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Xem == true)
          this.thamsohethong = true;
        else
          this.thamsohethong = false;
      }

      //nhacungcap: boolean = true;
      //sanpham: boolean = true;
      //khohang: boolean = true;


      }

    this.ngon_ngu = JSON.parse(localStorage.getItem('ngon_ngu'));
    if (this.ngon_ngu == null)
      this.ngon_ngu = "1";

    

  }
  changechinhanh(row) {
    this.tendonvi = row.Ten;

    this.repo.getRequest('api/Login/doichinhanh/' + row.Id)
      .subscribe(response => {

        var currentUser1 = localStorage.getItem('currentUser');
        let data = JSON.parse(currentUser1);
        data.id_don_vi = row.Id;
        data.ten_don_vi = row.Ten;
        localStorage.setItem('currentUser', JSON.stringify(data));
        window.location.reload();
      });
  }
    public ngonngu(text: string) {
      return this.repo.NgonNgu(text);
    }
    ngOnInit() {
        this.isNavSearchVisible = false;

        var ua = window.navigator.userAgent;
        if (ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }

        // Switch fullscreen icon indicator
        //const el = this.fsbutton.nativeElement.firstElementChild;
        //screenfull.on('change', () => {
        //    if (el)
        //        el.className = screenfull.isFullscreen ? 'fa fa-compress' : 'fa fa-expand';
        //});

        this.router = this.injector.get(Router);

        // Autoclose navbar on mobile when route change
        this.router.events.subscribe((val) => {
            // scroll view to top
            window.scrollTo(0, 0);
            // close collapse menu
            this.navCollapsed = true;
        });

    }

    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.toggleLayoutSetting('offsidebarOpen');
    }

    toggleCollapsedSideabar() {
        this.settings.toggleLayoutSetting('isCollapsed');
    }

    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }

    toggleFullScreen(event) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
  }
  ChonNgonNgu(id: any) {
    this.ngon_ngu = id;
    if (this.username) {
      let data1 = {
        Id: null,
        Type: null,
        Data: JSON.stringify({ NgonNgu: id, UserName: this.username })
      };

      

      this.repo.postRequest("api/donvi/CapNhatUser/", data1)
        .subscribe(response => {
          let tttdata = JSON.parse(localStorage.getItem('currentUser'));
          tttdata.ngon_ngu = id;
          localStorage.setItem('currentUser', JSON.stringify(tttdata));
          localStorage.setItem('ngon_ngu', id);

          this.repo.getRequest("api/login/getdsngongu/", { ngonnguid: id })
            .subscribe(response => {
              localStorage.setItem('NgonNgus', JSON.stringify(response.dsngonngu));
              this.translateservice.setLanguage(id);
            });

          

          //location.reload();
          window.location.reload();
          //location.href = '#/home';
        });


    }
    else {
      this.repo.getRequest("api/login/getdsngongu/", { ngonnguid: id })
        .subscribe(response => {
          localStorage.setItem('NgonNgus', JSON.stringify(response.dsngonngu));
          localStorage.setItem('ngon_ngu', id);
         // location.href = '#/home';
          //location.reload();
          this.translateservice.setLanguage(id);

          window.location.reload();
        });

    }


  }
  logout() {

    console.log("Xoa cookie trên Angular")
    localStorage.removeItem('currentUser');
    location.href = '/Home/Logout';
    //this.authenticationService.logout();

    //this.router.navigate(['/home']);
  }
}
